// Modules
import { NgModule, NO_ERRORS_SCHEMA, Injectable } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { VendorModule } from './vendor/vendor.module';
import { BuyerModule } from './buyer/buyer.module';
import { UserModule } from './user/user.module';
import { CoreModule } from './core/core.module';
import { Angulartics2Module } from 'angulartics2';
import { HighchartsChartModule } from 'highcharts-angular';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ROUTES } from './app.routes';
import { AuthInterceptor } from './auth/auth.interceptor';

// import { ItemDetailDesktopComponent } from './shared/item-detail-desktop/item-detail-desktop.component';
import { SafeHtmlPipe } from './shared/pipes/safe-html.pipe';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { Ng5SliderModule } from 'ng5-slider';
import { NgxSliderModule } from '@angular-slider/ngx-slider';

//Swipe module
import * as Hammer from 'hammerjs';
import { HammerGestureConfig, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';

@Injectable()
export class MyHammerConfig extends HammerGestureConfig  {
  overrides = <any>{
      // override hammerjs default configuration
      'swipe': { direction: Hammer.DIRECTION_ALL  }
  }
};



// Services
import { AuthService } from './auth/auth.service';
import { AuthGuardService } from './auth/auth-guard.service';
import { GoogleAnalyticsService } from './services/google-analytics.service';
import { EmailService } from './services/email.service';
import { UserService } from './user/user.service';
import { PageErrorService } from './page-error/page-error.service';
import { TopCategoriesFileSaverService } from './buyer/catalog/top-categories/top-categories-file-saver.service';
import { SharedService } from './shared/shared.service';
import { GlobalSearchService } from './services/search.service';
import { SessionService } from './services/session.service';
import { ResetPasswordService } from './shared/services/reset-password.service';
import { CookieService } from 'ngx-cookie-service';

// Components
import { TopComponent } from './buyer/top/top.component';
import { TopMobileComponent } from './buyer/top/top-mobile/top-mobile.component';
import { AppComponent } from './app.component';
import { PageErrorComponent } from './page-error/page-error.component';
import { MainTopComponent } from './main-top/main-top.component';
import { MainBodyComponent } from './main-body/main-body.component';
import { TopVendorComponent } from './vendor/top-vendor/top-vendor.component';
import { TopCategoriesComponent } from './buyer/catalog/top-categories/top-categories.component';
import { GuestTopComponent } from './buyer/top/guest-top/guest-top.component';
import { GuestModalComponent } from './buyer/guest-login/guest-modal/guest-modal.component';
import { GuestRegistrationComponent } from './buyer/guest-login/guest-registration/guest-registration.component';
import { GuestLoginComponent } from './buyer/guest-login/guest-login/guest-login.component';
import { GuestLoginMobileComponent } from './buyer/guest-login/guest-login-mobile/guest-login-mobile.component';
import { GuestRegistrationMobileComponent } from './buyer/guest-login/guest-registration-mobile/guest-registration-mobile.component';
import { BonusOfferComponent } from './buyer/guest-login/bonus-offer/bonus-offer.component';
import { BonusOfferFullComponent } from './buyer/guest-login/bonus-offer-full/bonus-offer-full.component';
import { StaticModule } from './static/static.module';
import { LoginComponent } from './user/login/login.component';
import { BulkUploadComponent } from './buyer/cart/bulk-upload/bulk-upload.component';
import { ConfirmModalComponent } from './shared/confirm-modal/confirm-modal.component';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { UserFiltersTypeaheadComponent } from './buyer/user-filters/user-filters-typeahead/user-filters-typeahead.component';
import { PricelistLoaderComponent } from './shared/ui-components/pricelist-loader/pricelist-loader.component';
import { TopVendorMobileComponent } from './vendor/top-vendor/top-vendor-mobile/top-vendor-mobile.component';

// PIPES
import { BlackCategoriesImagesPipe } from './shared/pipes/black-categories-images.pipe';
import { BlackLogosOutletPipe } from './shared/pipes/black-logos-outlet.pipe';
import { DropdownCategoriesComponent } from './buyer/categories/dropdown-categories.component';
import { GuestTopFullComponent } from './buyer/top/guest-top-full/guest-top-full.component';
import { MainTopMobileComponent } from './main-top/main-top-mobile/main-top-mobile.component';
import { VersionNotifierComponent } from './shared/version-notifier/version-notifier.component';
import { SharedModule } from './shared/shared.module';
import { GuestTopMobileComponent } from './buyer/top/guest-top/guest-top-mobile/guest-top-mobile.component';
import { LoaderService } from './shared/services/loader.service';
import { environment } from '../environments/environment';
import { GoogleTagManagerModule } from 'angular-google-tag-manager';


